import React from 'react';
import { connect } from 'react-redux';
import api from '../../../utils/api';
import CircularProgress from 'material-ui/CircularProgress';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import Dropzone from 'react-dropzone';
import { push } from 'connected-react-router';
import { Col, Row } from 'react-flexbox-grid';

class UploadArticlesView extends React.Component {
    onSubmit = values => {};

    constructor(props) {
        super(props);
        this.state = {
            file: null,
        };
    }

    componentDidMount = () => {};

    handleClose = () => {
        this.props.dispatch(push('/branches'));
    };

    submitUploadArticlesForm = () => {
        var data = new FormData();
        data.append('file', this.state.file);
        data.append('branch_ids[]', this.props.match.params.branch_id);
        this.props.uploadArticles({ data: data, isUploading: true });
    };

    readableDataFormat = data_format => {
        switch (data_format) {
            case 'h4_f3':
                return 'H4000 - F3000';
            case 'f2':
                return 'F2000';
        }
        return '';
    };

    onDrop = files => {
        this.setState(
            Object.assign({}, this.state, {
                file: files[0],
            })
        );
    };

    render = () => {
        const addArticlesActions = [
            <FlatButton label="Abbrechen" primary={true} onClick={this.handleClose} />,
            <FlatButton
                label="Artikel hochladen"
                primary={true}
                disabled={!this.state.file || this.props.isFetching}
                keyboardFocused={true}
                onClick={this.submitUploadArticlesForm}
            />,
        ];

        return (
            <div>
                <Dialog
                    title={`Artikeldaten mit Satzaufbau ${this.readableDataFormat(
                        this.props.data_format
                    )} hochladen`}
                    modal={false}
                    actions={addArticlesActions}
                    open={true}
                    onRequestClose={this.handleClose}>
                    <Row>
                        <Col xs={6}>
                            <Dropzone onDrop={this.onDrop}>
                                {({getRootProps}) => (
                                    <div {...getRootProps()}>
                                        <div style={{ padding: '20px' }}>
                                            {this.props.isUploading && <CircularProgress />}
                                            {!this.props.isUploading && this.state.file && (
                                                <div>{this.state.file.name}</div>
                                            )}
                                            {!this.props.isUploading && !this.state.file && (
                                                <div>
                                                    Ziehen Sie eine Datei per Drag-&-Drop in diese Fläche
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                            </Dropzone>
                        </Col>
                        <Col xs={6}>
                            {this.props.errors.get('file') == 'invalid_file' && (
                                <span>
                                    Die Datei ist nicht im richtigen Format! Bitte laden Sie eine
                                    CSV-Datei mit den korrekten Kopfdaten hoch.
                                </span>
                            )}

                            {this.props.errors.get('file') == 'missing_file' && (
                                <span>Sie haben keine Datei ausgewählt!</span>
                            )}
                        </Col>
                    </Row>
                </Dialog>
            </div>
        );
    };
}

const mapStateToProps = (state, props) => ({
    errors: state.branches.get('errors'),
    data_format: state.user.get('data_format'),
    isFetching: state.branches.get('isFetching'),
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    uploadArticles: payload => dispatch(api.actions.branches.uploadArticles(payload)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UploadArticlesView);
